module.exports = __webpack_public_path__ + "static/media/homem_r1_c7.15c400e9.jpg";